// redux-persist 加密存储:持久化的本地数据以 AES-GCM 密文落盘,避免明文暴露
import storage from 'redux-persist/lib/storage';
import { encryptText, decryptText } from './crypto';

export const encryptedStorage = {
  getItem: async (key: string): Promise<string | null> => {
    const raw = await storage.getItem(key);
    if (!raw) return raw;
    try {
      return await decryptText(raw);
    } catch {
      // 密钥变更/解密失败时回退原值,避免阻断启动
      return raw;
    }
  },
  setItem: async (key: string, value: string): Promise<void> => {
    try {
      await storage.setItem(key, await encryptText(value));
    } catch {
      await storage.setItem(key, value);
    }
  },
  removeItem: (key: string): Promise<void> => storage.removeItem(key),
};
